import React from 'react';
import PropTypes from 'prop-types';
import impstyles from '../styles/SearchStyles.module.scss';
import ListItemButton from '@mui/material/ListItemButton';
import { CustomTooltip } from './common/NavigationButton';

const SearchResultItem = ({ item, selectedID, handleClick }) => {

  return (
    <CustomTooltip
      title={`${item.vendorName} #${item.vendorNbr} Cat. #${item.category}`}
      tipPosition="left"
      data-testid="SearchResultItem"
    >
      <ListItemButton
        selected={selectedID === item.itemNbr}
        data-testid="ListItem"
        className={
          impstyles.searchListItem +
          (selectedID === item.itemNbr
            ? ' ' + impstyles.searchListItemSelected
            : '')
        }
        onClick={e => {
          handleClick(e, item);
        }}
      >
        <div className={impstyles.itemContainer}>
          <img
            height="72"
            width="72"
            className={impstyles.itemImage}
            src={
              item.itemImgUrl
                ? item.itemImgUrl
                : "/No_Image.jpg"
            }
            alt="Item"
            border="0"
          />
          <div className={impstyles.itemInfo}>
            <div className={impstyles.itemNumber} data-testid="itemNumber">
              {item.itemNbr}
              <br />
            </div>
            <div className={impstyles.itemDescribe} data-testid="itemDescription">{item.itemDesc}</div>
          </div>
        </div>
      </ListItemButton>
    </CustomTooltip>
  );
};

SearchResultItem.propTypes = {
  item: PropTypes.shape({
    vendorName: PropTypes.string,
    vendorNbr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    category: PropTypes.string,
    itemNbr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    itemImgUrl: PropTypes.string,
    itemDesc: PropTypes.string
  }).isRequired,
  selectedID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleClick: PropTypes.func.isRequired
};

export default SearchResultItem;
